import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 12px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      text-align: center;
    }
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 16px 0px 0px;
    text-align: center;
    width: 540px;
  `}
`;

export const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 40px 0px 0px;
`;
